import React from 'react'
import { SellOfferList } from "./list/page";

export const SellOffersPage = (): JSX.Element => {
  return <SellOfferList></SellOfferList>
}
